import React, { createContext, useContext, useEffect, useState } from "react"
import { ContactResponse, ContactResponseTaas, TMContact } from "../types/contactRetrieve.type"
import {
  ListOfTmEaiSttCreate,
  SRDetails,
  TmAccountIntegration,
  TmTroubleTicketIntegration,
} from "../types/srtt.type"
import {
  CustomerReport,
  NttData,
  OpenTicketDetails,
  SIEBEL_GATED,
} from "../types/diagnose.type"
import { useLoadingData } from "./LoadingContext"
import { useUserDetails } from "./UserContext"
import { useAuthContext } from "./AuthContext"
import { useDiagnoseData } from "./DiagnoseContext"
import { navigate } from "gatsby-link"
import {
  contactRetrieve,
  contactRetrieveTaas,
  createCTT,
  createCTTTaas,
  createSR,
} from "../services/createTicket.service"
import {
  SRTTServiceAdvisoryTable1,
  FIELD_TEAM_REMARK,
} from "../constants/create_ticket"
import { filterOpenTickets, getSpiceFaultRemark, isAuthFailure } from "../helpers/helper"
import { customerCheckTaas } from "../services/diagnose.service"
import { TICKET_TYPE } from "../enums/CreateTicket"
import { GTagID } from "../enums/GTagID"

type IssueDetails = {
  SR: {
    type: string
    area: string
    subarea: string
    casecatagory: string
  }
  CTT: {
    ticketsubtype: string
    serviceaffected: string
    category: string
    symptom: string
    summary: string
  }
}

type IContext = {
  contacts?: ContactResponse
  contactsTaas?: ContactResponseTaas
  cttDetails?: TmTroubleTicketIntegration
  contactList?: TMContact[]
  issueType?: TICKET_TYPE
  iwsTicketDetails?:any
  issueText: string
  srDetails?: SRDetails
  srfDetails?: SRDetails
  selectedContact?: TMContact
  handleGetContactList: () => Promise<void>
  handleGetContactListTaas: () => Promise<void>
  handleSetIssueType: (issueType: TICKET_TYPE) => void
  handleSRCttCreate: (data: number) => Promise<void>
  handleCttCreateTaas: (data: number, contact: any) => Promise<void>
  handleAddNewContact: (data: TMContact[]) => void
  handleAddNewContactTaas: (data: TMContact[]) => void
  handleSetIwsTicketDetails: (iwsTicketDetails: any, iwsTriggeredAction: string) => void
}

const CreateTicketContext = createContext<IContext>({
  issueText: "",
  handleSetIssueType: () => {},
  handleGetContactListTaas: async () => {},
  handleCttCreateTaas: async () => {},
  handleAddNewContactTaas: async () => {},
  handleGetContactList: async () => {},
  handleSRCttCreate: async () => {},
  handleAddNewContact: async () => {},
  handleSetIwsTicketDetails: () => {},
})

export const useCreateTicketData = () => useContext(CreateTicketContext)

type CreateReportProviderProps = {
  children: React.ReactNode
}

export const CreateReportProvider: React.FC<CreateReportProviderProps> = ({
  children,
}) => {
  const { setLoading } = useLoadingData()
  const { customerAcc, selectedServiceAccountTaas } = useUserDetails()
  const [issueType, setIssueType] = useState<TICKET_TYPE>()
  const [issueText, setIssueText] = useState<string>("")
  const [issueDetails, setIssueDetails] = useState<IssueDetails>()
  const [srfDetails, setSRFDetails] = useState<SRDetails>()
  const [cttDetails, setCTTDetails] = useState<TmTroubleTicketIntegration>()

  const [srDetails, setSRDetails] = useState<SRDetails>()
  const [contactList, setContactList] = useState<TMContact[]>([])
  
  const [selectedContact, setSelectedContact] = useState<TMContact>()
  const [contacts, setContacts] = useState<ContactResponse | ContactResponseTaas>({
    ListOfTmEaiRetrieveCustInfoIo: {
      TmAccountIntegration: [],
    },
  })
  const { tokenDetails, taasTokenDetails } = useAuthContext()
  const { customerReportData, openTicketDetails, activeServiceAccount,selectedSystemName, iwsAccount, serviceCustomerRowId, customerRowIdsForLookup } = useDiagnoseData()
  const [iwsTicketDetails, setIwsTicketDetails] = useState<any>([]);
  const [iwsActionItem, setIwsActionItem] = useState<string>("");
  // True while a ticket creation is in flight. SPICE takes around 21 seconds, and
  // the Submit control was never disabled, so repeated taps each started their own
  // creation. The 11-13 Sep export showed 8 services with cases seconds apart and
  // byte-identical content - one of them six tickets within seven seconds.
  // A ref rather than state: this must take effect on the very next call, before
  // React has had a chance to re-render.
  const creatingTicketRef = React.useRef(false)
  const handleSetIssueType = (issueType: TICKET_TYPE) => {
;
    setIssueType(issueType)
  }
  const handleSetIwsTicketDetails= (iwsTicketDetails: any, iwsTriggeredAction:string) => {
    ;
    setIwsTicketDetails(iwsTicketDetails);
    setIwsActionItem(iwsTriggeredAction);
  }
  const handleDiagnoseData = () => {
    if(selectedSystemName == 'NOVA'){
      function isObjectBlank(key: keyof SIEBEL_GATED) {
        if (gated && gated[key]) {
          const checkObjLength = Object.keys(gated[key])
          if (checkObjLength.length == 0) {
            return true
          }
          return false
        }
        return true
      }
      let gated: SIEBEL_GATED | undefined =
        customerReportData?.expert &&
        customerReportData?.expert.SRTT_Ticket_Recommendation.result.siebel[0]
          .gated
      let predictedClass = customerReportData?.expert.predictedclass
      let spicePriorityClass =
        customerReportData?.expert.SRTT_Ticket_Recommendation.result.siebel[0]
          .gated.priorityclass
      let priorityClass: any = SRTTServiceAdvisoryTable1.Table1.find(
        i => i.PriorityClass === spicePriorityClass
      )
  
      if (!priorityClass) {
        if (customerReportData?.expert.accessType === "FTTH") {
          let advisoryClass = SRTTServiceAdvisoryTable1.Table2.filter(
            i => i.AccessType === "FTTH"
          )
          priorityClass = advisoryClass.find(
            i => i.AdvisoryClass === predictedClass
          )
        }
  
        if (customerReportData?.expert.accessType === "VDSL") {
          let advisoryClass = SRTTServiceAdvisoryTable1.Table2.filter(
            i => i.AccessType === "VDSL"
          )
          priorityClass = advisoryClass.find(
            i => i.AdvisoryClass === predictedClass
          )
        }
      }
  
      let gatedArr = []
      if (gated) {
        gatedArr = Object.keys(gated)
      }
      let Status = priorityClass
        ? priorityClass.srstatus
        : localStorage.getItem("ticketStatus")
      let closerReason =
        Status == "Closed" ? "Resolved After Troubleshooting" : ""
  
      const myRe = /:([^I]*)/
      const result =
        customerReportData?.expert &&
        myRe.exec(customerReportData?.expert.inbound)
  
      // CTT Calc
  
      var CAMELIA = result && result[1]
  
      var symptomCode = ""
      if (
        customerReportData?.expert.SRTT_Ticket_Recommendation.result.siebel[0]
          .gated.CTTLOV
      ) {
        symptomCode =
          customerReportData?.expert.SRTT_Ticket_Recommendation.result.siebel[0]
            .gated.CTTLOV.cttsymptomcode
      }
      // symptomCode =  customerReportData?.expert.SRTT_Ticket_Recommendation.result.siebel[0].gated.CTTLOV.cttsymptomcode;
      if (symptomCode == "Any Related") {
        var category =
          customerReportData?.expert.SRTT_Ticket_Recommendation.result.siebel[0]
            .gated.CTTLOV.cttcategory
        if (category == "Failure") {
          symptomCode = "Line Disconnect"
        }
        if (category == "Performance") {
          symptomCode = "Slow Browsing"
        }
      }
  
      // Result
  
      setIssueDetails({
        SR: {
          type: priorityClass
            ? priorityClass.srtype
            : customerReportData?.expert.SRTT_Ticket_Recommendation.result
                .siebel[0].gated.SRFLOV.srtype,
          area: priorityClass
            ? priorityClass.srarea
            : customerReportData?.expert.SRTT_Ticket_Recommendation.result
                .siebel[0].gated.SRFLOV.srarea,
          casecatagory: priorityClass
            ? priorityClass.srcasecategory
            : customerReportData?.expert.SRTT_Ticket_Recommendation.result
                .siebel[0].gated.SRFLOV.srcasecategory,
          subarea: priorityClass
            ? priorityClass.subarea
            : customerReportData?.expert.SRTT_Ticket_Recommendation.result
                .siebel[0].gated.SRFLOV.subarea,
        },
        CTT: {
          ticketsubtype: priorityClass ? priorityClass.TicketSubType : "Reactive",
          category: priorityClass
            ? priorityClass.cttcategory
            : customerReportData?.expert.SRTT_Ticket_Recommendation.result
                .siebel[0].gated.CTTLOV.cttcategory,
          serviceaffected: "",
          symptom: priorityClass ? priorityClass.cttsymptomcode : symptomCode,
          summary: "",
        },
      })
    } else {

      let ticketsubtype: string = customerReportData?.expert.SRTT_Ticket_Recommendation?.result.gated?.CASELOV ? customerReportData?.expert.SRTT_Ticket_Recommendation?.result.gated?.CASELOV.ticket_type_code
                      : "";
      let category = customerReportData?.expert.SRTT_Ticket_Recommendation?.result?.gated?.CASELOV ? customerReportData?.expert.SRTT_Ticket_Recommendation?.result.gated?.CASELOV.category : "";
      let serviceaffected = customerReportData?.expert.SRTT_Ticket_Recommendation?.result.gated?.CASELOV ? customerReportData?.expert.SRTT_Ticket_Recommendation?.result.gated?.CASELOV.service_affected : "";
      let symptom = customerReportData?.expert.SRTT_Ticket_Recommendation?.result.gated?.CASELOV.symptom_code ? customerReportData?.expert.SRTT_Ticket_Recommendation?.result.gated?.CASELOV.symptom_code : "";
        let summary = customerReportData?.expert &&
      customerReportData?.expert.summary;
      setIssueDetails({
        SR: {
          type: '',
          area: '',
          casecatagory: '',
          subarea: '',
        },
        CTT: {
          ticketsubtype: ticketsubtype,
          category: category,
          serviceaffected: serviceaffected,
          symptom: symptom,
          summary: summary,
        },
      })
    }
    
  }

  const handleManualTroubleshootData = () => {
    setIssueDetails({
      SR: {
        type: "Fault",
        area: "Service Failure",
        subarea: "All Services Down",
        casecatagory: "Line Disconnect",
      },
      CTT: {
        ticketsubtype: "Proactive",
        category: "Failure",
        serviceaffected: "HSI",
        symptom: "Line Disconnect",
        summary: `
        Manual diagnose & troubleshoot performed:
        Symptom: Connection failure.
          1. CPE rebooted.
          2. Checked modem & router power condition - Power LED is OFF.
          3. Checked CPE power socket. - Power LED is still OFF. 
          4. Diagnosed as CPE faulty - Proceed to create report.
        `,
      },
    })
  }

  useEffect(() => {
    switch (issueType) {
      case TICKET_TYPE.PHYSICAL_NETWORK_CONDITION:
        setIssueText(`<h3 id = ${GTagID.create_report_troubleshoot}>Physical Network Health Condition</h3>
        <div className="show-message-mobile">
          <p>
            Uh-oh! There's something wrong with your Unifi
            connection. This requires a technician to visit to
            your premises and fix the problem.
          </p>

          <p>Please tap the button below to create a report.</p>
        </div>`)
        handleDiagnoseData()
        break
      case TICKET_TYPE.CONNECTION_FAILURE_ISSUE:
        setIssueText(`<h3 id = ${GTagID.create_report_manual_troubleshoot}>Manual Troubleshoot Issue</h3>
        <div className="show-message-mobile">
          <p>
          Uh-oh! Your Unifi equipment is faulty and require replacement. For this, a technician visit to your premise is required to check and replace with a new one.
          </p>

          <p>Please tap the button below to create a report.</p>
        </div>`)
        handleManualTroubleshootData()

        break

      default:
        break
    }
  }, [issueType])

  const handleGetContactListTaas = async () => {
    setLoading(true, "Getting your contacts")

      const bodyRequest = {
        ListOfTmEaiRetrieveCustInfoIo: {
          TmAccountIntegration: [
            {
              //  CustomerName: customer.name,
              CustomerName:
                selectedServiceAccountTaas?.CustomerAccount.name,
              // Read contacts from the record the case will be created against,
              // so the contact and the case live on the same customer record.
              CustomerRowId:
                serviceCustomerRowId ||
                selectedServiceAccountTaas?.CustomerAccount.CustomerRowId
            },
          ],
        },
      }

      if (taasTokenDetails?.access_token) {
        const randomstring = await randomString(16, true, true, true, false);
        try {
          const contactResponse = await contactRetrieveTaas(
            taasTokenDetails?.access_token,
            bodyRequest,
            randomstring
          )
           if (contactResponse?.Status.Type === "OK") {
            setContacts(contactResponse.Response)
            setContactList(
              contactResponse.Response.ListOfTmEaiRetrieveCustInfoIo
                .TmAccountIntegration[0].ListOfTmContactIntegration
                .TmContactIntegration
            )
          }
        } catch (error) {} // Leave blank for future reference
      }
      setLoading(false, "")
    
  }

  const handleGetContactList = async () => {
    setLoading(true, "Getting your contacts")
    let sourceSystem = "NOVA"

    if (sourceSystem === "NOVA") {

      const bodyRequest = {
        ListOfTmEaiRetrieveCustInfoIo: {
          TmAccountIntegration: [
            {
              CustomerID:
              activeServiceAccount &&
              activeServiceAccount.CustomerAccount.customerInfo.EncryptedCustomerIdNumber, //customer.idNumber,
              //  CustomerName: customer.name,
              CustomerName:
              activeServiceAccount &&
              activeServiceAccount.CustomerAccount.customerInfo.EncryptedName,
            },
          ],
        },
      }

      if (tokenDetails?.access_token) {
        try {
          const contactResponse = await contactRetrieve(
            tokenDetails?.access_token,
            bodyRequest
          )
          if (contactResponse?.status.type === "OK") {
            setContacts(contactResponse.response)
            setContactList(
              contactResponse.response.ListOfTmEaiRetrieveCustInfoIo
                .TmAccountIntegration[0].ListOfTmContactIntegration
                .TmContactIntegration
            )
          }
        } catch (error) {} // Leave blank for future reference
      }
      setLoading(false, "")
    }
  }
 

  const handleAddNewContact = (data: TMContact[]) => {

    setContactList(prevState => {
      const newContactList = [...prevState]
      newContactList.concat(data)
      return newContactList
    })
  }

  const handleAddNewContactTaas = (data: any) => {

    const addedcontact = {
      ContactRowID: data[0].ContactRowID,
      MobilePhone: data[0].ContactMobilePhone,
      EmailAddress: data[0].ContactEmailAddress,
      HomePhone: data[0].ContactHomePhone,
      ContactName: data[0].ContactName,
      OfficePhone: data[0].ContactOfficePhone,
    }

    setContactList(prevState => {
      const newContactList = [...prevState]
      newContactList.push(addedcontact)
      return newContactList
    })
  }

  const handleCttCreateTaasInner = async (data: number, contact:any)=>{
    setLoading(true, "Creating your ticket");

    // The open-ticket check runs at the start of diagnosis, but the case is only
    // created here - after the ~21s diagnosis, the result page, contact
    // selection and Submit. That gap is minutes, and another system can raise a
    // case inside it. The 26 Aug sample shows NOCGRID raising the first case and
    // EasyFix a second, one of them only a minute later.
    //
    // So ask again immediately before creating. Uses the same lookup and the
    // same filterOpenTickets rule as the diagnosis-time check, including the
    // agreed 30-day window.
    //
    // Deliberately fails open: only a positively identified open ticket stops
    // creation. If the lookup errors or returns something unrecognised we carry
    // on, because blocking on an unhealthy lookup would stop customers raising
    // genuine tickets.
    if (taasTokenDetails?.access_token) {
      try {
        // Check every customer record this customer holds, not just the one
        // RetrieveCustomerAccount returned. Cases raised through NOCGRID, UCC
        // and the other channels sit under a different record, and this
        // re-check had the same blind spot as the main check. Issue #54.
        const recheckIds =
          customerRowIdsForLookup && customerRowIdsForLookup.length
            ? customerRowIdsForLookup
            : [selectedServiceAccountTaas?.CustomerAccount?.CustomerRowId]

        const recheckOpen: any[] = []
        let recheckAnswered = false
        for (let i = 0; i < recheckIds.length; i++) {
          const id = String(recheckIds[i] ?? "").trim()
          if (!id) continue
          const recheckRandomString = await randomString(16, true, true, true, false);
          const recheck: any = await customerCheckTaas(
            taasTokenDetails.access_token,
            { BundleRowId: id },
            recheckRandomString
          );
          // An expired session here is the most dangerous case of all - it is
          // the last check before the ticket is created. Without this the 401
          // body, which carries no Status object, left recheckAnswered false
          // and the ticket was created with nothing having been checked.
          if (isAuthFailure(recheck)) {
            setLoading(false, "")
            navigate("/app/error?reason=session")
            return
          }

          if (String(recheck?.Status?.Type ?? "").toUpperCase() === "OK") {
            recheckAnswered = true
            const open = filterOpenTickets(recheck?.Response?.SRDetailsReturn)
            if (open && open.length) recheckOpen.push(...open)
          }
        }

        if (recheckAnswered) {
          const stillOpen = recheckOpen;
          if (stillOpen.length > 0) {
            console.warn(
              `Open ticket found on re-check (created ${stillOpen[0]?.CreatedDate}, status ${stillOpen[0]?.Status}) - not creating a duplicate`
            );
            setLoading(false, "");
            navigate("/app/result");
            return;
          }
        }
      } catch (error) {
        console.warn("Open-ticket re-check failed, continuing", error);
      }
    }

    let contactName: string = "";
    let contactPhone: string = "";
    const isEmpty = (obj:any) => Object.getOwnPropertyNames(obj).length === 0;
    if(!isEmpty(contact)){
       contactName = contact[0].ContactName;
       contactPhone = contact[0].ContactMobilePhone;
       const SelectedContact = contact[0]; //retrieve contact info
       const addedcontact:any = 
       {
         "MobilePhone": contact[0].ContactMobilePhone,
         "EmailAddress": contact[0].ContactEmailAddress,
         "HomePhone": null,
         "ContactName": contact[0].ContactName,
     
      }
   setSelectedContact(addedcontact);
    } else {
       contactName = contactList[data].ContactName;
       contactPhone = contactList[data].MobilePhone;
       const SelectedContact = contactList[data] //retrieve contact info
    setSelectedContact(SelectedContact)
    }
    const accountDetails:any = selectedServiceAccountTaas;
    let ctt;
    if (taasTokenDetails?.access_token) {
      
    // let product = ""
    // if (
    //   customerReportData?.expert.SRTT_Ticket_Creation.ServiceRowID ==
    //   "HIS"
    // ) {
    //   product = "Residential High Speed"
    // }
    // if (
    //   customerReportData?.expert.SRTT_Ticket_Creation.ServiceRowID ==
    //   "VOBB"
    // ) {
    //   product = "Residential Voice"
    // }
    // var CCPChargingMethod = localStorage.getItem("CCPChargingMethod");
    // var symptomCode = ""
    // if (
    //   customerReportData?.expert.SRTT_Ticket_Recommendation.result
    //     .siebel[0].gated.CTTLOV
    // ) {
    //   symptomCode =
    //     customerReportData?.expert.SRTT_Ticket_Recommendation.result
    //       .siebel[0].gated.CTTLOV.cttsymptomcode
    // }
    // symptomCode =  customerReportData?.expert.SRTT_Ticket_Recommendation.result.siebel[0].gated.CTTLOV.cttsymptomcode;
    // if (symptomCode == "Any Related") {
    //   var category =
    //     customerReportData?.expert.SRTT_Ticket_Recommendation.result
    //       .siebel[0].gated.CTTLOV.cttcategory
    //   if (category == "Failure") {
    //     symptomCode = "Line Disconnect"
    //   }
    //   if (category == "Performance") {
    //     symptomCode = "Slow Browsing"
    //   }
    // }
    // const novaCTTRequestModel = {
    //   ListOfTmEaiSttCreate: {
    //     TmAccountIntegration: {
    //       AccountNo: customerAcc && customerAcc[0].AccountNo,
    //       ListOfTmTroubleTicketIntegration: {
    //         TmTroubleTicketIntegration: {
    //           Id: "1",
    //           BillingAccountNo:
    //             customerReportData?.expert.SRTT_Ticket_Creation
    //               .BillingAccountNo,
    //           Category: issueDetails?.CTT.category,
    //           AssetId:
    //             customerReportData?.expert.SRTT_Ticket_Creation
    //               .ServiceRowID, //no ref in doc
    //           ContactId: contact && contact[0].ContactRowID, //customerContact Row ID
    //           Description: CAMELIA,
    //           // customerReportData?.expert.inbound,
    //           RelatedSRRowID:
    //             SRFapiResponse.response.ListOfTmEaiSttCreateSr
    //               .TmServiceRequestIntegration.Id,
    //           Owner: "WIDER_TMUC_TECH_SOC2", //default to sr group which has default value WIDER_TMUC_TECH_SOC2
    //           Product: product,
    //           Severity: "4-Low", //no need to send //on 14-09-2021 kairual confirm that
    //           Source: "EASY FIX", //default
    //           Status: priorityClass
    //             ? priorityClass.cttstatus
    //             : "In Progress", //SRF then CTT scneario default
    //           SymptomCode: issueDetails?.CTT.symptom, //as per farid confirmed on 14/09/2021
    //           ContactDetailReported:
    //             SelectedContact && SelectedContact.ContactRowID,
    //           TicketSubType: issueDetails?.CTT.ticketsubtype, //default
    //           TicketType: priorityClass
    //             ? priorityClass.CttTicketType
    //             : "Customer Trouble Ticket", //default
    //           CCPChargingMethod: "Renewal Service Contract",
    //           TMPreferredAcknowledgement: "Mobile", //no ref in doc
    //           ListOfTmActionIntegration3: {
    //             TmActionIntegration3: {
    //               ActivityId: "1",
    //               ActivityStatus: "Un-Scheduled",
    //               ActivityType: priorityClass
    //                 ? priorityClass.ActivityType
    //                 : customerReportData?.expert
    //                     .SRTT_Ticket_Recommendation.result.siebel[0]
    //                     .gated.activity.activity_type,
    //             },
    //           },
    //           ListOfTmTroubleTicketNotesIntegration: {
    //             TmTroubleTicketNotesIntegration: {
    //               CreatedBy: "EAI_USER", //default
    //               NoteId: "1", //default
    //               NoteDescription: CAMELIA,
    //               // customerReportData?.expert.inbound,
    //               NoteType: "Note", //default
    //               CreatedByPosition: "EAI", //default
    //             },
    //           },
    //         },
    //       },
    //     },
    //   },
    // }
    let ticketsubtype: string = customerReportData?.expert.SRTT_Ticket_Recommendation?.result.gated?.CASELOV ? customerReportData?.expert.SRTT_Ticket_Recommendation?.result.gated?.CASELOV.ticket_type_code
                      : "";
      let category = customerReportData?.expert.SRTT_Ticket_Recommendation?.result?.gated?.CASELOV ? customerReportData?.expert.SRTT_Ticket_Recommendation?.result.gated?.CASELOV.category : "";
      let serviceaffected = customerReportData?.expert.SRTT_Ticket_Recommendation?.result.gated?.CASELOV ? customerReportData?.expert.SRTT_Ticket_Recommendation?.result.gated?.CASELOV.service_affected : "";
      let symptom = customerReportData?.expert.SRTT_Ticket_Recommendation?.result.gated?.CASELOV.symptom_code ? customerReportData?.expert.SRTT_Ticket_Recommendation?.result.gated?.CASELOV.symptom_code : "";
        let summary = customerReportData?.expert &&
      customerReportData?.expert.summary;

      let serviceNumber: string = "";
      activeServiceAccount?.ServiceDetails?.Products
    .forEach((data:any) => {
      if (data.SerialNumber.indexOf("@") == -1 && data.SerialNumber == "Residential Voice Basic") {
        serviceNumber = data.SerialNumber;
      } else if(data.SerialNumber.indexOf("@unifi") !== -1 || data.SerialNumber.indexOf("@unifibiz") !== -1) {
        serviceNumber = data.SerialNumber;
      } else {

      }
      
    })
    const body = {
      // Create the case against the record the service is actually attached
      // to. EasyFix used to send the record RetrieveCustomerAccount returns,
      // which for many customers has no service attached or belongs to a
      // different service - so NOCGRID, UCC and the other channels could not
      // see our cases and raised duplicates. Issue #57.
      //
      // Falls back to the old value if the service could not be resolved, so a
      // lookup failure still creates the case rather than blocking the customer.
      "CustomerRowId":
        serviceCustomerRowId || accountDetails?.CustomerAccount.CustomerRowId,
      "ServiceNumber": serviceNumber,
      "ContactName": contactName,
      "ContactPhone": contactPhone,
      "ContactEmail": "",
      "TicketType": customerReportData?.expert.SRTT_Ticket_Recommendation?.result.gated?.CASELOV.ticket_type_code,
      "TicketSubtype": customerReportData?.expert.SRTT_Ticket_Recommendation?.result.gated?.CASELOV.ticket_sub_type,
      // The real fault detail from SPICE lives in expert.inbound (the CAMELIA
      // remark) or expert.summary. gated.CASELOV comes back as an empty object,
      // which is why the note was arriving blank. FIELD_TEAM_REMARK stays as the
      // fallback for when SPICE returns nothing usable at all.
      "NoteDescription":
        getSpiceFaultRemark(customerReportData?.expert) || FIELD_TEAM_REMARK,
      "Category": customerReportData?.expert.SRTT_Ticket_Recommendation?.result.gated?.CASELOV.category,
      "SymptomCode": customerReportData?.expert.SRTT_Ticket_Recommendation?.result.gated?.CASELOV.symptom_code,
      "Severity": "4-Low",
	    "ActivityType": "RNO Troubleshooting",
	    "ActivityStatus": "Un-Scheduled"
    };

    //const bodyRequest = novaCTTRequestModel;
    const randomstring = await randomString(16, true, true, true, false);
    const apiResponse = await createCTTTaas(
      taasTokenDetails?.access_token,
      body,
      randomstring
    );

    if (
      (apiResponse.Status && apiResponse.Status.Code !== 0) ||
      (apiResponse.Status && apiResponse.Status.Type === "NOK")
    ) {
      navigate("/app/error")
    }
     ctt = {
      Status: 'In Progress',
      TTNumber: apiResponse.Response.CaseId
    };
    // localStorage.setItem("CTTDetails", JSON.stringify(ctt))

    setCTTDetails(ctt)
    }
    
    setLoading(false, "")

    if (ctt?.TTNumber) {
      navigate("/app/ticket-success")
    }
    if (!ctt?.TTNumber) {
      navigate("/app/error")
    }

    return
  }

  const handleSRCttCreateInner = async (data: number) => {
   
    if(iwsActionItem != "" && iwsActionItem!= ""){
      console.log("iwsAccount", iwsAccount);
      console.log("iwsTicketDetails", iwsTicketDetails);
      console.log("IwsActionItem",iwsActionItem);
      setLoading(true, "Creating your ticket")
      let ctt
      const SelectedContact = contactList && contactList[data] //retrieve contact info
      setSelectedContact(SelectedContact)
      var bodyRequest
      let contact = contactList;
      const novaSRFRequestModel = {
        ListOfTmEaiSttCreateSr: {
          TmServiceRequestIntegration: {
            Id: "1", //hard code
            CustomerRowID:
              customerReportData?.expert.SRTT_Ticket_Creation.CustomerRowID,
            ServiceRowID:
              customerReportData?.expert.SRTT_Ticket_Creation.ServiceRowID,
            BillingAccountRowID:
              customerReportData?.expert.SRTT_Ticket_Creation
                .BillingAccountRowID,
            BillingAccountNo:
              customerReportData?.expert.SRTT_Ticket_Creation
                .BillingAccountNo,
            ClosureCategory: "", //cond
            CallBack: "Yes", //not mandetory
            ContactDetailRowID:
              customerReportData?.expert.SRTT_Ticket_Creation
                .PrimaryContactRowID,
            DetailedDescription: "Refer Notes for details", //default
            Owner: "WIDER_TMUC_TECH_SOC2",
            Area: "Service Failure",//sr_area
            Type: "Fault", //sr_type
            SubArea: "All Services Down",
            Source: "EASY FIX", //default
            Status: "In Progress",
            ClosureReason: "",
            CaseCategory: "Line Disconnect", //confussion
            ContactDetailReported:
              SelectedContact && SelectedContact.ContactRowID,
            ListOfTmFinServiceRequestNotesIntegration: {
              TMFINServiceRequestNotesIntegration: [
                {
                  CreatedBy: "EAI", //default
                  NoteId: "1", //default
                  NoteType: "Note", //default
                  CreatedByPosition: "EAI", //default
                  NoteDescription: customerReportData?.expert.summary,
                },
              ],
            },
          },
        },
      }

      bodyRequest = novaSRFRequestModel
      if (tokenDetails && tokenDetails.access_token) {
        const SRFapiResponse = await createSR(
          tokenDetails.access_token,
          bodyRequest
        )
        if (
          (SRFapiResponse.status && SRFapiResponse.status.code !== 0) ||
          !SRFapiResponse.status
        ) {
          console.warn("err")
          navigate("/app/error")
        }
        if (
          (SRFapiResponse.status && SRFapiResponse.status.type == 'NOK') ||
          !SRFapiResponse.status
        ) {
          console.warn("err")
          navigate("/app/error")
        }
        const SRNumber =
        SRFapiResponse.response.ListOfTmEaiSttCreateSr
          .TmServiceRequestIntegration
      setSRFDetails(SRNumber)
        const novaCTTRequestModel = {
          ListOfTmEaiSttCreate: {
            TmAccountIntegration: {
              AccountNo: activeServiceAccount &&
              activeServiceAccount.CustomerAccount.customerInfo.AccountNo,
              ListOfTmTroubleTicketIntegration: {
                TmTroubleTicketIntegration: {
                  Id: "1",
                  BillingAccountNo:
                    customerReportData?.expert.SRTT_Ticket_Creation
                      .BillingAccountNo,
                  Category: iwsTicketDetails.category,
                  AssetId:
                    customerReportData?.expert.SRTT_Ticket_Creation
                      .ServiceRowID, //no ref in doc
                  ContactId: contact && contact[0].ContactRowID, //customerContact Row ID
                  Description: "Fault Location= Customer Site, Condition=Caution Remark: Inside premise and check connection between ONU and RG. ONU power off/power related issue.",
                  // customerReportData?.expert.inbound,
                  RelatedSRRowID:
                    SRFapiResponse.response.ListOfTmEaiSttCreateSr
                      .TmServiceRequestIntegration.Id,
                  Owner: "WIDER_TMUC_TECH_SOC2", //default to sr group which has default value WIDER_TMUC_TECH_SOC2
                  Product: "",
                  Severity: "4-Low", //no need to send //on 14-09-2021 kairual confirm that
                  Source: "EASY FIX", //default
                  Status: "In Progress", //SRF then CTT scneario default
                  SymptomCode: iwsTicketDetails.symptomCode, //as per farid confirmed on 14/09/2021
                  ContactDetailReported:
                    SelectedContact && SelectedContact.ContactRowID,
                  TicketSubType: issueDetails?.CTT.ticketsubtype, //default
                  TicketType: iwsTicketDetails.ticketType, //default
                  CCPChargingMethod: "One - Off Payment",
                  TMPreferredAcknowledgement: "Mobile", //no ref in doc
                  ListOfTmActionIntegration3: {
                    TmActionIntegration3: {
                      ActivityId: "1",
                      ActivityStatus: "Un-Scheduled",
                      ActivityType: iwsTicketDetails.activityType,
                    },
                  },
                  ListOfTmTroubleTicketNotesIntegration: {
                    TmTroubleTicketNotesIntegration: {
                      CreatedBy: "EAI_USER", //default
                      NoteId: "1", //default
                      NoteDescription: "Your Unifi service unable to be fully diagnosed.",
                      // customerReportData?.expert.inbound,
                      NoteType: "Note", //default
                      CreatedByPosition: "EAI", //default
                    },
                  },
                },
              },
            },
          },
        }
        bodyRequest = novaCTTRequestModel
        const apiResponse = await createCTT(
          tokenDetails.access_token,
          bodyRequest
        )
        if (
          (apiResponse.status && apiResponse.status.code !== 0) ||
          (apiResponse.Status && apiResponse.Status.Type === "NOK")
        ) {
          navigate("/app/error")
        }
        ctt =
          apiResponse.response.ListOfTmEaiSttCreate.TmAccountIntegration
            .ListOfTmTroubleTicketIntegration.TmTroubleTicketIntegration
        // localStorage.setItem("CTTDetails", JSON.stringify(ctt))

        setCTTDetails(ctt)
        setLoading(false, "")

      if (ctt?.TTNumber) {
        navigate("/app/ticket-confirm")
      }
      if (!ctt?.TTNumber) {
        navigate("/app/error")
      }
      }
      return
    } else {
      setLoading(true, "Creating your ticket")
      let ctt, SRDetails
      function isObjectBlank(key: keyof SIEBEL_GATED) {
        if (gated && gated[key]) {
          const checkObjLength = Object.keys(gated[key])
          if (checkObjLength.length == 0) {
            return true
          }
          return false
        }
        return true
      }
      let gated: SIEBEL_GATED | undefined =
        customerReportData?.expert &&
        customerReportData?.expert.SRTT_Ticket_Recommendation.result.siebel[0]
          .gated
      let predictedClass = customerReportData?.expert.predictedclass
      let spicePriorityClass =
        customerReportData?.expert.SRTT_Ticket_Recommendation.result.siebel[0]
          .gated.priorityclass
      let priorityClass: any = SRTTServiceAdvisoryTable1.Table1.find(
        i => i.PriorityClass === spicePriorityClass
      )
  
      if (!priorityClass) {
        if (customerReportData?.expert.accessType === "FTTH") {
          let advisoryClass = SRTTServiceAdvisoryTable1.Table2.filter(
            i => i.AccessType === "FTTH"
          )
          priorityClass = advisoryClass.find(
            i => i.AdvisoryClass === predictedClass
          )
        }
  
        if (customerReportData?.expert.accessType === "VDSL") {
          let advisoryClass = SRTTServiceAdvisoryTable1.Table2.filter(
            i => i.AccessType === "VDSL"
          )
          priorityClass = advisoryClass.find(
            i => i.AdvisoryClass === predictedClass
          )
        }
      }
  
      let gatedArr = []
      if (gated) {
        gatedArr = Object.keys(gated)
      }
      const SelectedContact = contactList && contactList[data] //retrieve contact info
      setSelectedContact(SelectedContact)
      let Status = priorityClass
        ? priorityClass.srstatus
        : localStorage.getItem("ticketStatus")
      let closerReason =
        Status == "Closed" ? "Resolved After Troubleshooting" : ""
  
      const myRe = /:([^I]*)/
      const result =
        customerReportData?.expert &&
        myRe.exec(customerReportData?.expert.inbound)
      var CAMELIA = result && result[1]
  
      let sourceSystem = "NOVA"
      var bodyRequest
  
      if (sourceSystem === "NOVA") {
        let contact = contactList
        // if((!isObjectBlank("SRFLOV")) && (gatedArr.includes('SRFLOV') || priorityClass.srtype==="Fault")){
        if (!isObjectBlank("SRFLOV")) {
          const novaSRFRequestModel = {
            ListOfTmEaiSttCreateSr: {
              TmServiceRequestIntegration: {
                Id: "1", //hard code
                CustomerRowID:
                  customerReportData?.expert.SRTT_Ticket_Creation.CustomerRowID,
                ServiceRowID:
                  customerReportData?.expert.SRTT_Ticket_Creation.ServiceRowID,
                BillingAccountRowID:
                  customerReportData?.expert.SRTT_Ticket_Creation
                    .BillingAccountRowID,
                BillingAccountNo:
                  customerReportData?.expert.SRTT_Ticket_Creation
                    .BillingAccountNo,
                ClosureCategory: Status == "Closed" ? "Customer" : "", //cond
                CallBack: "Yes", //not mandetory
                ContactDetailRowID:
                  customerReportData?.expert.SRTT_Ticket_Creation
                    .PrimaryContactRowID,
                DetailedDescription: "Refer Notes for details", //default
                Owner: "WIDER_TMUC_TECH_SOC2",
                Area: issueDetails?.SR.area, //sr_area
                Type: issueDetails?.SR.type, //sr_type
                SubArea: issueDetails?.SR.subarea,
                Source: "EASY FIX", //default
                Status: Status ? Status : "In Progress",
                ClosureReason: closerReason,
                CaseCategory: issueDetails?.SR.casecatagory, //confussion
                ContactDetailReported:
                  SelectedContact && SelectedContact.ContactRowID,
                ListOfTmFinServiceRequestNotesIntegration: {
                  TMFINServiceRequestNotesIntegration: [
                    {
                      CreatedBy: "EAI", //default
                      NoteId: "1", //default
                      NoteType: "Note", //default
                      CreatedByPosition: "EAI", //default
                      NoteDescription: customerReportData?.expert.summary,
                    },
                  ],
                },
              },
            },
          }
  
          bodyRequest = novaSRFRequestModel
          if (tokenDetails && tokenDetails.access_token) {
            const SRFapiResponse = await createSR(
              tokenDetails.access_token,
              bodyRequest
            )
            
            if (
              (SRFapiResponse.status && SRFapiResponse.status.code !== 0) ||
              !SRFapiResponse.status
            ) {
              console.warn("err")
              navigate("/app/error")
            }
            if (
              (SRFapiResponse.status && SRFapiResponse.status.type == 'NOK') ||
              !SRFapiResponse.status
            ) {
              console.warn("err")
              navigate("/app/error")
            }
            const SRNumber =
              SRFapiResponse.response.ListOfTmEaiSttCreateSr
                .TmServiceRequestIntegration
            setSRFDetails(SRNumber)
            // if((!isObjectBlank("CTTLOV")) && (gatedArr.includes('CTTLOV') || priorityClass.CttTicketType)){
            if (!isObjectBlank("CTTLOV")) {
              let product = ""
              if (
                customerReportData?.expert.SRTT_Ticket_Creation.ServiceRowID ==
                "HIS"
              ) {
                product = "Residential High Speed"
              }
              if (
                customerReportData?.expert.SRTT_Ticket_Creation.ServiceRowID ==
                "VOBB"
              ) {
                product = "Residential Voice"
              }
              // var CCPChargingMethod = localStorage.getItem("CCPChargingMethod");
              var symptomCode = ""
              if (
                customerReportData?.expert.SRTT_Ticket_Recommendation.result
                  .siebel[0].gated.CTTLOV
              ) {
                symptomCode =
                  customerReportData?.expert.SRTT_Ticket_Recommendation.result
                    .siebel[0].gated.CTTLOV.cttsymptomcode
              }
              // symptomCode =  customerReportData?.expert.SRTT_Ticket_Recommendation.result.siebel[0].gated.CTTLOV.cttsymptomcode;
              if (symptomCode == "Any Related") {
                var category =
                  customerReportData?.expert.SRTT_Ticket_Recommendation.result
                    .siebel[0].gated.CTTLOV.cttcategory
                if (category == "Failure") {
                  symptomCode = "Line Disconnect"
                }
                if (category == "Performance") {
                  symptomCode = "Slow Browsing"
                }
              }
              const novaCTTRequestModel = {
                ListOfTmEaiSttCreate: {
                  TmAccountIntegration: {
                    AccountNo: activeServiceAccount &&
                    activeServiceAccount.CustomerAccount.customerInfo.AccountNo,
                    ListOfTmTroubleTicketIntegration: {
                      TmTroubleTicketIntegration: {
                        Id: "1",
                        BillingAccountNo:
                          customerReportData?.expert.SRTT_Ticket_Creation
                            .BillingAccountNo,
                        Category: issueDetails?.CTT.category,
                        AssetId:
                          customerReportData?.expert.SRTT_Ticket_Creation
                            .ServiceRowID, //no ref in doc
                        ContactId: contact && contact[0].ContactRowID, //customerContact Row ID
                        Description: CAMELIA,
                        // customerReportData?.expert.inbound,
                        RelatedSRRowID:
                          SRFapiResponse.response.ListOfTmEaiSttCreateSr
                            .TmServiceRequestIntegration.Id,
                        Owner: "WIDER_TMUC_TECH_SOC2", //default to sr group which has default value WIDER_TMUC_TECH_SOC2
                        Product: product,
                        Severity: "4-Low", //no need to send //on 14-09-2021 kairual confirm that
                        Source: "EASY FIX", //default
                        Status: priorityClass
                          ? priorityClass.cttstatus
                          : "In Progress", //SRF then CTT scneario default
                        SymptomCode: issueDetails?.CTT.symptom, //as per farid confirmed on 14/09/2021
                        ContactDetailReported:
                          SelectedContact && SelectedContact.ContactRowID,
                        TicketSubType: issueDetails?.CTT.ticketsubtype, //default
                        TicketType: priorityClass
                          ? priorityClass.CttTicketType
                          : "Customer Trouble Ticket", //default
                        CCPChargingMethod: "Renewal Service Contract",
                        TMPreferredAcknowledgement: "Mobile", //no ref in doc
                        ListOfTmActionIntegration3: {
                          TmActionIntegration3: {
                            ActivityId: "1",
                            ActivityStatus: "Un-Scheduled",
                            ActivityType: priorityClass
                              ? priorityClass.ActivityType
                              : customerReportData?.expert
                                  .SRTT_Ticket_Recommendation.result.siebel[0]
                                  .gated.activity.activity_type,
                          },
                        },
                        ListOfTmTroubleTicketNotesIntegration: {
                          TmTroubleTicketNotesIntegration: {
                            CreatedBy: "EAI_USER", //default
                            NoteId: "1", //default
                            NoteDescription: CAMELIA,
                            // customerReportData?.expert.inbound,
                            NoteType: "Note", //default
                            CreatedByPosition: "EAI", //default
                          },
                        },
                      },
                    },
                  },
                },
              }
              bodyRequest = novaCTTRequestModel
              const apiResponse = await createCTT(
                tokenDetails.access_token,
                bodyRequest
              )
             
            
              if (
                (apiResponse.status && apiResponse.status.code !== 0) ||
                (apiResponse.Status && apiResponse.Status.Type === "NOK")
              ) {
                navigate("/app/error")
              }
              ctt =
                apiResponse.response.ListOfTmEaiSttCreate.TmAccountIntegration
                  .ListOfTmTroubleTicketIntegration.TmTroubleTicketIntegration
              // localStorage.setItem("CTTDetails", JSON.stringify(ctt))
  
              setCTTDetails(ctt)
            }
  
            // if((!isObjectBlank("SRCLOV")) && gatedArr.includes('SRCLOV')){
            if (!isObjectBlank("SRCLOV")) {
              const novaSRCRequestModel = {
                ListOfTmEaiSttCreateSr: {
                  TmServiceRequestIntegration: {
                    Id: "1", //hard code
                    CustomerRowID:
                      customerReportData?.expert.SRTT_Ticket_Creation
                        .CustomerRowID,
                    ServiceRowID:
                      customerReportData?.expert.SRTT_Ticket_Creation
                        .ServiceRowID,
                    BillingAccountRowID:
                      customerReportData?.expert.SRTT_Ticket_Creation
                        .BillingAccountRowID,
                    BillingAccountNo:
                      customerReportData?.expert.SRTT_Ticket_Creation
                        .BillingAccountNo,
                    ClosureCategory: Status == "Closed" ? "Customer" : "", //cond
                    CallBack: "Yes", //not mandetory
                    ContactDetailRowID:
                      customerReportData?.expert.SRTT_Ticket_Creation
                        .PrimaryContactRowID,
                    DetailedDescription: "Refer Notes for details", //default
                    Owner:
                      customerReportData?.expert.SRTT_Ticket_Recommendation.result
                        .siebel[0].gated.src_assignment,
                    Area: priorityClass
                      ? priorityClass.srarea
                      : customerReportData?.expert.SRTT_Ticket_Recommendation
                          .result.siebel[0].gated.SRCLOV.srarea, //sr_area
                    Type: priorityClass
                      ? priorityClass.srtype
                      : customerReportData?.expert.SRTT_Ticket_Recommendation
                          .result.siebel[0].gated.SRCLOV.srtype, //sr_type
                    SubArea: priorityClass
                      ? priorityClass.subarea
                      : customerReportData?.expert.SRTT_Ticket_Recommendation
                          .result.siebel[0].gated.SRCLOV.subarea,
                    Source: "EASY FIX", //default
                    Status: "Assigned",
                    ClosureReason: "Customer Request", //impliment cond
                    CaseCategory: priorityClass
                      ? priorityClass.srcasecategory
                      : customerReportData?.expert.SRTT_Ticket_Recommendation
                          .result.siebel[0].gated.SRCLOV.srcasecategory, //confussion
                    ContactDetailReported:
                      SelectedContact && SelectedContact.ContactRowID,
                    ListOfTmFinServiceRequestNotesIntegration: {
                      TMFINServiceRequestNotesIntegration: [
                        {
                          CreatedBy: "EAI", //default
                          NoteId: "1", //default
                          NoteType: "Note", //default
                          CreatedByPosition: "EAI", //default
                          NoteDescription: customerReportData?.expert.summary,
                        },
                      ],
                    },
                  },
                },
              }
  
              bodyRequest = novaSRCRequestModel
              var apiResponse = await createSR(
                tokenDetails.access_token,
                bodyRequest
              )
              if (
                (apiResponse.status && apiResponse.status.code !== 0) ||
                (apiResponse.Status && apiResponse.Status.Type === "NOK")
              ) {
                navigate("/app/error")
              }
  
              SRDetails =
                apiResponse.response.ListOfTmEaiSttCreateSr
                  .TmServiceRequestIntegration
              // localStorage.setItem("SRCDetails", JSON.stringify(SRNumber))
              setSRDetails(SRDetails)
            }
          }
        }
      }
      setLoading(false, "")

      if (SRDetails?.SRNumber || ctt?.TTNumber) {
        navigate("/app/ticket-confirm")
      }
      if (!SRDetails?.SRNumber && !ctt?.TTNumber) {
        navigate("/app/error")
      }
      return
    }
    
    
  }
  // Lets only the first call through until it settles. Applied to both creators,
  // so it also covers NewContactModal, which calls them directly after adding a
  // contact. The flag is always cleared in finally, including on the paths that
  // navigate away to /app/error, so a customer who returns can try again.
  const withCreateGuard = (createTicket: (...args: any[]) => Promise<any>) => {
    return async (...args: any[]) => {
      if (creatingTicketRef.current) {
        console.warn("Ticket creation already in progress - ignoring repeat submit")
        return
      }
      creatingTicketRef.current = true
      try {
        return await createTicket(...args)
      } finally {
        creatingTicketRef.current = false
      }
    }
  }

  const handleCttCreateTaas = withCreateGuard(handleCttCreateTaasInner)
  const handleSRCttCreate = withCreateGuard(handleSRCttCreateInner)

  const randomString = async (length:any, includeLowercase = true, includeUppercase = true, includeNumbers = true, includeSpecial = false) =>  {
    let characters = '';
    
    if (includeLowercase) characters += 'abcdefghijklmnopqrstuvwxyz';
    if (includeUppercase) characters += 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    if (includeNumbers) characters += '0123456789';
    if (includeSpecial) characters += '!@#$%^&*()_+[]{}|;:,.<>?';
  
    let result = '';
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * characters.length));
    }
    return result;
  }
  const context = React.useMemo(
    () => ({
      contactList,
      contacts,
      srDetails,
      issueType,
      iwsTicketDetails,
      issueText,
      cttDetails,
      srfDetails,
      selectedContact,
      handleGetContactList,
      handleGetContactListTaas,
      handleSRCttCreate,
      handleCttCreateTaas,
      handleSetIssueType,
      handleAddNewContact,
      handleAddNewContactTaas,
      handleSetIwsTicketDetails,
    }),
    [
      contactList,
      contacts,
      srDetails,
      issueType,
      iwsTicketDetails,
      issueText,
      srfDetails,
      cttDetails,
      selectedContact,
      handleGetContactList,
      handleGetContactListTaas,
      handleSRCttCreate,
      handleCttCreateTaas,
      handleSetIssueType,
      handleAddNewContact,
      handleAddNewContactTaas,
      handleSetIwsTicketDetails,
    ]
  )
  return (
    <CreateTicketContext.Provider value={context}>
      {children}
    </CreateTicketContext.Provider>
  )
}
